<template>
  <div>
    <ul>
      <li v-for="(n, i) in slicedNews" :key="i">
        <div>
          <a :href="n.link">{{ n.title }}</a>
          <span class="muted--text ml-2">{{ $dayjs.date(n.pubDate) }}</span>
        </div>
      </li>
    </ul>
    <div class="text-right text-md-left">
      <v-btn :href="$federation.links.news" text color="primary">
        {{ $t("common:button.SeeAllNews", "See all news") }}
        <v-icon right color="primary" small>$iconExternalLink</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from "vue";
export default defineComponent({
  name: "AppNewsList",
  props: {
    news: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const slicedNews = computed(() => props.news.slice(0, 10));

    return {
      slicedNews
    };
  }
});
</script>
<style scoped>
ul {
  list-style: none;
  position: relative;
  padding-left: 0 !important;
}
ul li::before {
  content: " ";
  position: absolute;
  display: block;
  border: 1px solid var(--v-primary-base);
  height: 18px;
  transform: translate(0px, 3px);
}
ul li {
  margin: 8px 4px;
}
ul li div {
  padding-left: 20px;
}
</style>
